import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { money } from "@/lib/site";

const Row = ({ k, v }) => (
  <div className="flex justify-between gap-6 py-2 border-b border-slate-100 text-sm">
    <span className="text-slate-600">{k}</span>
    <span className="font-medium text-right break-all">{v || "—"}</span>
  </div>
);

export const LeadDetail = ({ lead, onClose }) => (
  <Dialog open={!!lead} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-lg" data-testid="lead-detail-dialog">
      {lead && (
        <>
          <DialogHeader><DialogTitle className="font-display text-2xl">{lead.business_name}</DialogTitle></DialogHeader>
          <div>
            <Row k="Contact" v={lead.contact_name} />
            <Row k="Email" v={<a className="text-[var(--cobalt)]" href={`mailto:${lead.email}`}>{lead.email}</a>} />
            <Row k="Phone" v={<a className="text-[var(--cobalt)]" href={`tel:${lead.phone}`}>{lead.phone}</a>} />
            <Row k="Business type" v={lead.business_type} />
            <Row k="Monthly volume" v={money(lead.monthly_volume)} />
            <Row k="Current rate" v={lead.current_rate != null ? `${lead.current_rate}%` : ""} />
            <Row k="Services" v={(lead.services || []).join(", ")} />
            <Row k="Statement review" v={lead.statement_review ? "Requested" : "No"} />
            <Row k="Emails" v={`Owner ${lead.owner_email_sent ? "✓" : "pending"} · Client ${lead.client_email_sent ? "✓" : "pending"}`} />
            <Row k="Submitted" v={new Date(lead.created_at).toLocaleString()} />
            {lead.message && <p className="mt-4 text-sm text-slate-700 whitespace-pre-wrap bg-slate-50 rounded-xl p-4">{lead.message}</p>}
          </div>
        </>
      )}
    </DialogContent>
  </Dialog>
);
